import { getResource, postForm } from './BaseRequests'

export const fetchFavourites = (success, fail) => {
    getResource("favourites").then(success).catch(fail)
}

export const addFavourite = (productId, success, fail) => {
    postForm("favourites", {action: 'add', id: productId}, false).then(success).catch(fail)
}

export const deleteFavourite = (productId, success, fail) => {
    postForm("favourites", { action: 'delete', id: productId }, false).then(success).catch(fail)
}